import React from "react";
import { Row, Checkbox, Form } from "antd";
// import PropTypes from 'prop-types'

const rowStyles = { marginBottom: 8 };
const checkBoxElem = { lineHeight: "15px" };
const formItemLayout = {
  // labelCol: { xs:{span:24},sm:{span:8},md:{span:8},lg:{span:6} },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16, offset: 8 },
    md: { span: 12, offset: 8 },
    lg: { span: 10, offset: 6 },
  },
  style: { marginBottom: 12 },
};
// style={rowStyles}
function SelectAll(props) {
  const selectStyles =
    props.selectStyles !== undefined ? props.selectStyles : formItemLayout;
  return (
    <Form.Item {...selectStyles}>
      <Row>
        <Checkbox
          disabled={
            typeof props.disabled === "boolean" ? props.disabled : false
          }
          checked={props.allHotels}
          onChange={props.handleSelectChange}
          style={checkBoxElem}
        >
          {typeof props.label === "string"
            ? props.label
            : "Select all hotels in the group"}
        </Checkbox>
      </Row>
    </Form.Item>
  );
}

// SelectAll.propTypes = {

// }

export default SelectAll;
